import type { FetchZoneListParams } from 'Services/ControlDataManagement/Features/Zone/types'
import { useGetZonesQuery } from 'Services/ControlDataManagement/Features/Zone/zoneApi'
import { ROWS_PER_PAGE_DEFAULT, SORT_ORDER_ASC } from 'Util/constants'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SELECTED_ZONE_PARAMETER_KEY = 'selectedZone'

function useZonesWithParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  const [params, setParams] = useState<FetchZoneListParams>({
    sort_by: searchParams.get('sort_by') ?? 'id',
    sort_order: searchParams.get('sort_order') ?? SORT_ORDER_ASC,
    start_index: searchParams.get('start_index') ?? undefined,
    count: ROWS_PER_PAGE_DEFAULT
  })

  const selectedZoneQueryParam = searchParams.get(SELECTED_ZONE_PARAMETER_KEY) ?? undefined
  const [selectedZoneId, setSelectedZoneId] = useState(selectedZoneQueryParam)

  const {
    data: { resources: zones } = { resources: [] },
    data: { total_results: totalResults } = { total_results: 0 },
    isFetching,
    refetch
  } = useGetZonesQuery(params)

  const setQueryParams = () => {
    for (const [key, value] of Object.entries(params)) {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    }

    selectedZoneId && searchParams.set(SELECTED_ZONE_PARAMETER_KEY, selectedZoneId)

    setSearchParams(searchParams)
  }

  useEffect(() => {
    setQueryParams()
  }, [params])

  useEffect(() => {
    if (selectedZoneId) {
      setQueryParams()
    } else {
      searchParams.delete(SELECTED_ZONE_PARAMETER_KEY)
      setSearchParams(searchParams)
    }
  }, [selectedZoneId])

  return {
    zones,
    isFetching,
    totalResults,
    params,
    setParams,
    selectedZoneId,
    setSelectedZoneId,
    fetchZones: refetch
  }
}

export default useZonesWithParams
